import PropTypes from 'prop-types';
import { useState } from 'react';

import { checkBenefitForMember } from 'api/scopeAssessorAPI';
import { EnrollmentCheckDialog } from 'components/enrollment/EnrollmentCheckDialog';
import { EnrollmentHistory } from 'components/enrollment/EnrollmentHistory';

const CANNOT_FETCH_MESSAGE = 'Missing member or plan information for benefit check.';

export const EnrollmentTab = ({
    payerId = undefined,
    segmentId = undefined,
    memberDetails = undefined,
    refetchMemberDetails,
}) => {
    const [isEnrollmentCheckDialogOpen, setIsEnrollmentCheckDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [displayMemberDetails, setDisplayMemberDetails] = useState(undefined);

    const resetDialogState = () => {
        setIsLoading(false);
        setErrorMessage(undefined);
        setDisplayMemberDetails(undefined);
    };

    const handleCloseDialog = () => {
        setIsEnrollmentCheckDialogOpen(false);
        resetDialogState();
    };

    const handleRunEnrollmentCheck = async () => {
        const canFetch =
            payerId &&
            segmentId &&
            memberDetails?.memberId &&
            memberDetails?.firstName &&
            memberDetails?.lastName &&
            memberDetails?.dateOfBirth;

        setIsEnrollmentCheckDialogOpen(true);
        resetDialogState();

        if (!canFetch) {
            setErrorMessage(CANNOT_FETCH_MESSAGE);
            return;
        }

        setIsLoading(true);

        try {
            await checkBenefitForMember({
                payerId,
                segmentId,
                cardholderId: memberDetails?.memberId,
                dateOfBirth: memberDetails?.dateOfBirth,
                firstName: memberDetails?.firstName,
                lastName: memberDetails?.lastName,
            });

            const { data: refreshedMemberDetails } = await refetchMemberDetails();
            setDisplayMemberDetails(refreshedMemberDetails ?? memberDetails);
        } catch (err) {
            setErrorMessage(err?.message ?? 'Benefit check failed.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <EnrollmentCheckDialog
                isOpen={isEnrollmentCheckDialogOpen}
                onClose={handleCloseDialog}
                memberId={memberDetails?.memberId}
                memberDetails={displayMemberDetails}
                isLoading={isLoading}
                errorMessage={errorMessage}
            />
            <EnrollmentHistory
                payerId={payerId}
                memberId={memberDetails?.memberId}
                firstName={memberDetails?.firstName}
                lastName={memberDetails?.lastName}
                dateOfBirth={memberDetails?.dateOfBirth}
                memberDetails={memberDetails}
                onRunEnrollmentCheck={handleRunEnrollmentCheck}
            />
        </>
    );
};

EnrollmentTab.propTypes = {
    payerId: PropTypes.string,
    segmentId: PropTypes.string,
    memberDetails: PropTypes.shape({}),
    refetchMemberDetails: PropTypes.func.isRequired,
};
